<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other'}" tag="li" class="breadcrumb-item">
						<a href="#">其他資訊</a>
					</router-link>
					<div class="breadcrumb-item">
						{{$t('EzStaminaCalculate')}}
					</div>
				</ol>
			</nav>
			<div class="item-box mb-3">
				<h3 class="item-title">
					{{$t('EzStaminaCalculate')}}
				</h3>
				<div class="form-row align-items-center">
					<div class="col-md-12 my-1">
						<label for="inlineFormInputName">{{$t('CurrentLevel')}}</label>
						<input type="number" v-model="nowLv" class="form-control" id="inlineFormInputName" :max="maxLv.team_level">
						<span class="error">{{error_lv}}</span>
					</div>
					<div class="col-md-12 my-1">
						<label for="inlineFormInputGroupUsername">{{$t('CurrentStamina')}}</label>
						<div class="input-group">
							<input @keyup="calculate" @click="pressCalc=false" type="number" class="form-control" id="inlineFormInputGroupUsername" v-model="inputStamina" :max="maxLv.max_stamina">
						</div>
						<span class="error">{{error_stamina}}</span>
					</div>
				</div>
				<div class="row pt-3 align-items-center">
					<div class="col-auto">
						<div class="form-check">
							<input class="form-check-input" type="checkbox" id="autoSizingCheck2" v-model="remember">
							<label class="form-check-label" for="autoSizingCheck2">
								<label for="inlineFormInputGroupUsername">{{$t('RememberLevel')}}</label>
							</label>
						</div>
					</div>
					<div class="col-auto">
						<button @click="calculate(1)" type="submit" class="pcbtn primary">{{$t('Calculate')}}</button>
					</div>
				</div>
				<hr>
				{{$t('MaxStamina')}} <span style="font-size: 18px;" class="badge badge-info px-3 py-2 mb-2 mx-2">{{nowMax.max_stamina}}</span> {{$t('WhenStaminaFullTime')}} <span style="font-size: 18px;" class="badge badge-success px-4 py-2 mx-2">{{date}}</span>
			</div>
			<div class="item-box mb-3" v-if="pressCalc">
				<h3 class="item-title">
					{{$t('PlayerStaminaCost')}}
				</h3>
				<div class="item-content">
					<div v-for="n in checkStaminalist" class="mb-2">
						<div v-if="inputStamina - n*10 >= 0">
							{{$t('Remain')}}<span style="font-size: 16px; width: 60px" class="badge badge-info mb-2 py-2 mx-2">{{inputStamina - n*10}}</span>{{$t('Stamina')}} {{$t('WhenStaminaFullTime')}} <span style="font-size: 16px;" class="badge badge-success px-4 py-2 mx-2">{{getTime(n)}}</span>
						</div>
					</div>
				</div>
			</div>
			<div class="item-box">
				<h3 class="item-title">
					{{$t('PlayerStaminaExp')}}
				</h3>
				<table class="table table-bordered table-hover">
					<thead>
						<tr>
							<th width="25%">Lv</th>
							<th width="25%">{{$t('Stamina')}}</th>
							<th width="25%">{{$t('ExpToLevelUp')}}</th>
							<th width="25%">{{$t('Total')}}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,index) in staminaList">
							<td>{{item.team_level}}</td>
							<td>{{item.max_stamina}}</td>
							<td>{{item.now_exp}}</td>
							<td>{{item.total_exp}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
import experience_team from '../../assets/edata/experience_team.txt'
import moment from 'moment';
export default {
	name: 'Stamina',
	metaInfo: {
		title: '體力計算機',
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki',
		meta: [
			{ name: 'description', content: "超異域公主連結☆Re:Dive 的簡易體力計算表" }
		]
	},
	data() {
		return {
			staminaList: {},
			inputStamina: 20,
			nowLv: 1,
			time: '',
			date: '',
			maxLv: {},
			nowMax: {},
			error_lv: "",
			error_stamina: "",
			remember: false,
			error_time: "格式為 分:秒 AM/PM",
			inputTime: "",
			checkStaminalist: 0,
			pressCalc: false
		}
	},
	created: function() {
		var self = this;
		self.nowLv = this.$cookie.get('MyLevel');
		var experienceTeam = JSON.parse(self.atou(experience_team));
		var et = experienceTeam;
		var getNowExp = _.forEach(et, function(o, i) {
			if (i == 0) {
				o["now_exp"] = 0;
				return;
			}
			var nowExp = Number(o.total_exp) - Number(et[Number(i) - 1]["total_exp"]);
			o["now_exp"] = nowExp;
		});
		self.maxLv = _.last(et);
		self.staminaList = getNowExp;
	},
	computed: {

	},
	methods: {
		calculate: function(input) {
			var self = this;
			var inputStamina = self.inputStamina;
			var nowLv = self.nowLv;
			self.error_lv = "";
			self.error_stamina = "";

			var maxStamina = _.find(self.staminaList, function(o) { return o.team_level == nowLv; });
			if (_.isEmpty(maxStamina) || _.isNull(maxStamina)) {
				self.error_lv = this.$t('CurrentTopLevel') + (Number(self.maxLv.team_level) - 1);
				self.pressCalc = false;
				return;
			}
			if (nowLv > Number(self.maxLv.team_level)) {
				self.error_lv = this.$t('CurrentTopLevel') + (Number(self.maxLv.team_level) - 1);
				self.pressCalc = false;
				return;
			}
			if (Number(inputStamina) > Number(self.maxLv.max_stamina)) {
				self.error_stamina = this.$t('CurrentTopStamina') + self.maxLv.max_stamina;
				self.pressCalc = false;
				return;
			}
			if (Number(inputStamina) > Number(maxStamina.max_stamina)) {
				self.error_stamina = this.$t('CurrentTopStamina') + maxStamina.max_stamina;
				self.pressCalc = false;
				return;
			}
			if (self.remember) {
				this.$cookie.set('MyLevel', nowLv, 7);
			}
			self.nowMax = maxStamina;

			var lackingStamaina = Number(maxStamina.max_stamina) - inputStamina;
			var minutes = lackingStamaina * 6;
			var date = moment().add(minutes, 'm');
			self.date = moment().add(minutes, 'm').format('MM/DD HH:mm');
			var checkStaminalist = Math.floor(Number(inputStamina) / 10);
			self.checkStaminalist = checkStaminalist;
			if (1 == input) {
				self.pressCalc = true;
			}
		},
		getTime: function(number) {
			var inputStamina = this.inputStamina;
			var lackStamaina = inputStamina - Number(number) * 10;
			var d = this.date;
			var date = moment(d);
			date = date.add(number, 'h').format('MM/DD HH:mm');
			return date;
		}
	},
	mounted: function() {
		var self = this;
		this.calculate();
		self.inputTime = moment().add(18, 'h').format('HH:mm');
	}
}
</script>
<style rel="stylesheet/sass" lang="sass">
</style>